import Layout from '@/components/feature/Layout';
import { companyInfo } from '@/mocks/company';
import { products } from '@/mocks/products';
import { Link } from 'react-router-dom';

const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Máquina de Solda PEAD',
  description: 'Máquinas de solda para geomembrana PEAD — cunha quente e extrusoras compatíveis.',
  url: 'https://maquinadesoldageomembrana.com.br/maquina-de-solda-pead',
  inLanguage: 'pt-BR',
};

export default function PeadPage() {
  const peadMachines = products.filter((p) => p.compatibilidade.pead);

  return (
    <Layout>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="w-full px-4 md:px-6 lg:px-10 pt-28 md:pt-32 pb-16 md:pb-24">
        <nav className="text-xs text-foreground-400 mb-6">
          <Link to="/" className="hover:text-primary-600 cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line mx-1" />
          <Link to="/maquina-de-solda-de-geomembrana" className="hover:text-primary-600 cursor-pointer">Máquinas</Link>
          <i className="ri-arrow-right-s-line mx-1" />
          <span className="text-foreground-600">PEAD</span>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-12">
          <div className="lg:col-span-2">
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight mb-6">
              Máquina de Solda PEAD
            </h1>

            <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed space-y-4">
              <p>
                O <strong className="text-foreground-950">PEAD (Polietileno de Alta Densidade)</strong> é o material mais utilizado em geomembranas profissionais. As máquinas de solda para PEAD precisam atingir temperaturas específicas (tipicamente 350-450°C) com controle preciso, pois o PEAD exige calor suficiente para fusão sem degradação do material.
              </p>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 uppercase mt-8 mb-3">Solda de PEAD por Cunha Quente</h2>
              <p>
                A cunha quente é o método padrão para soldagem de geomembrana PEAD em grandes áreas. Cria duas linhas paralelas de solda com um <strong>canal de teste no meio</strong>, permitindo verificação de pressão e vazamento conforme norma <strong>NBR 16199</strong>. As máquinas BT950, CX500L e BT-GM1 são projetadas especificamente para PEAD de 0,5 a 3,0 mm.
              </p>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 uppercase mt-8 mb-3">Solda de PEAD por Extrusão</h2>
              <p>
                A extrusora aplica fio de PEAD fundido sobre a emenda. É essencial como <strong>equipamento complementar</strong> para cantos, emendas T, reparos e junções. As extrusoras como o modelo EX3 e Booster EX3 Plus utilizam grânulos de PEAD do mesmo tipo da geomembrana, garantindo compatibilidade química e uniformidade.
              </p>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 uppercase mt-8 mb-3">Espessuras e Temperatura</h2>
              <div className="bg-background-100 rounded-xl border border-background-200/70 p-5">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-background-200/70">
                      <th className="text-left py-2 text-foreground-900 font-bold uppercase text-xs">Espessura PEAD</th>
                      <th className="text-left py-2 text-foreground-900 font-bold uppercase text-xs">Potência Mínima</th>
                      <th className="text-left py-2 text-foreground-900 font-bold uppercase text-xs">Temperatura Ideal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-background-200/40"><td className="py-2">0,5 - 1,0 mm</td><td className="py-2">800 - 1400W</td><td className="py-2">300 - 350°C</td></tr>
                    <tr className="border-b border-background-200/40"><td className="py-2">1,0 - 2,0 mm</td><td className="py-2">1400 - 2000W</td><td className="py-2">350 - 400°C</td></tr>
                    <tr className="border-b border-background-200/40"><td className="py-2">2,0 - 3,0 mm</td><td className="py-2">2000 - 3400W</td><td className="py-2">380 - 450°C</td></tr>
                  </tbody>
                </table>
              </div>

              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 uppercase mt-8 mb-3">Equipamentos Recomendados</h2>
              <p>
                As máquinas de solda PEAD devem ser escolhidas com base na espessura da geomembrana. Para projetos com PEAD de 0,5-1,0 mm, cunhas de 800-1400W são suficientes. Para 2,0 mm ou mais, recomendamos equipamentos com potência superior a 2000W, como a BT-GM1.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-2">
              <Link to="/modelos-de-maquinas" className="text-sm text-primary-600 hover:text-primary-700 font-medium bg-primary-50 px-3 py-1.5 rounded-full cursor-pointer">Ver Todos os Modelos</Link>
              <Link to="/maquina-de-solda-de-geomembrana-preco" className="text-sm text-primary-600 hover:text-primary-700 font-medium bg-primary-50 px-3 py-1.5 rounded-full cursor-pointer">Ver Fatores de Preço</Link>
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-primary-50 rounded-2xl border border-primary-200/70 p-6">
              <h3 className="font-heading text-lg font-bold text-foreground-950 uppercase mb-3">Solicitar Orçamento</h3>
              <p className="text-foreground-500 text-sm leading-relaxed mb-5">Indicamos o equipamento ideal para sua espessura de PEAD.</p>
              <a href={whatsappUrl} target="_blank" rel="nofollow noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide">
                <i className="ri-whatsapp-line" /> Falar no WhatsApp
              </a>
            </div>

            <div className="bg-white rounded-2xl border border-background-200/70 p-5">
              <h4 className="font-heading text-sm font-bold text-foreground-900 uppercase mb-3">Compatíveis com PEAD ({peadMachines.length} modelos)</h4>
              <div className="space-y-3">
                {peadMachines.map((p) => (
                  <div key={p.id} className="flex items-start gap-3 py-3 border-b border-background-200/40 last:border-0">
                    <img alt={p.name} className="w-16 h-16 object-contain rounded-lg bg-background-100 flex-shrink-0" src={p.image} />
                    <div>
                      <p className="font-bold text-sm text-foreground-900">{p.name}</p>
                      <p className="text-foreground-400 text-xs">{p.specs.potencia} · {p.specs.temperatura}</p>
                      <p className="text-primary-600 text-xs font-bold mt-0.5">{p.specs.material}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}